import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateAssignmentMutationVariables = Types.Exact<{
  data: Types.UpdateAssignmentInput;
}>;


export type UpdateAssignmentMutation = { updateAssignment: { assignment: { id: string, assignmentNumber: number } } };


export const UpdateAssignmentDocument = /*#__PURE__*/ gql`
    mutation updateAssignment($data: UpdateAssignmentInput!) {
  updateAssignment(data: $data) {
    assignment {
      id
      assignmentNumber
    }
  }
}
    `;

export function useUpdateAssignmentMutation() {
  return Urql.useMutation<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>(UpdateAssignmentDocument);
};